import { render, staticRenderFns } from "./EmulatorColorMutationPreview.vue?vue&type=template&id=5b2069e3"
import script from "./EmulatorColorMutationPreview.vue?vue&type=script&lang=js"
export * from "./EmulatorColorMutationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports